import { useI18n } from 'builder/hooks/useI18n'
import { Container, Img } from './styles'
import ImgSrc from './img.svg'

export const TailoringFromPublicJobBoardBanner = () => {
  const { i18n } = useI18n()

  return (
    <Container>
      <Img src={ImgSrc} />
      <span>{i18n.t('builder.prefill_resume.auto_tailoring_view.banner')}</span>
    </Container>
  )
}
